/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserResourceProgressUpdateProgress } from './userResourceProgressUpdateProgress';

/**
 * store completed state of a resource and the progress
 */
export interface UserResourceProgressUpdate {
  completed: boolean;
  progress?: UserResourceProgressUpdateProgress;
}
